import { render, staticRenderFns } from "./PurchaseOrderTable.vue?vue&type=template&id=e06e6ec4&scoped=true"
import script from "./PurchaseOrderTable.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderTable.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderTable.vue?vue&type=style&index=0&id=e06e6ec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06e6ec4",
  null
  
)

export default component.exports